import React from 'react';
import ReactDOM from 'react-dom/client';
import './bootstrap-combined.scss';
import './index.css';
import App from './App';
import { INIT_FEATURE_FLAGS } from 'actions/Types';
import { Provider } from 'react-redux';
import store, { history } from './store';
import { ConnectedRouter } from 'connected-react-router';
import { getUserFromSession } from 'actions/user';
import { initFeatureFlags } from '@shoflo/polymer/helpers/Feature/Feature';
import { getEnvVar } from '@shoflo/polymer/utils/getEnvVar';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below.. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

store.dispatch(getUserFromSession());

let ldUser = {
  _id: 'login-anonymous',
  email: 'login-anonymous@shoflo.io',
  url: window.location.href,
  anonymous: true,
};

initFeatureFlags({ user: ldUser }, getEnvVar('REACT_APP_LAUNCHDARKLY_KEY'))
  .then(() => {
    store.dispatch({
      type: `${INIT_FEATURE_FLAGS}_SUCCESS`,
    });
  })
  .catch(() => {
    store.dispatch({
      type: `${INIT_FEATURE_FLAGS}_FAILURE`,
    });
  });
